import React from 'react';
import { Input, Radio, RadioGroup } from 'tdesign-react';

import { ImageRatio } from '@/const/richMedia';
import { ActivityType, OfficialActivity } from '@/interface/promotion';
import UploadPic from '@/material/form-upload/image';

import styles from './index.module.less';

export interface IProps {
  value: OfficialActivity;
  onChange: (key: any) => void;
  disabled?: boolean;
}

const CustomOfficialActivity: React.FC<IProps> = (props) => {
  const {
    value,
    onChange,
    disabled = false,
  } = props;

  const isQQ = value?.type === ActivityType.QQGROUP;
  const isH5 = value?.type === ActivityType.H5;

  return (
    <div className={styles.content}>
      <div className={styles.item}>
        类型
        <RadioGroup
          value={value?.type || ActivityType.DEFAULT}
          disabled={disabled}
          onChange={v => onChange({ ...value, type: v as ActivityType })}
        >
          <Radio value={ActivityType.QQGROUP}>QQ群</Radio>
          <Radio value={ActivityType.H5}>H5</Radio>
        </RadioGroup>
      </div>
      <div className={styles.item}>
        Logo
        <UploadPic
          value={value?.logo}
          disabled={disabled}
          onChange={v => onChange({ ...value, logo: v })}
          limit={{ ratio: ImageRatio.unlimited }}
        />
      </div>
      <div className={styles.item}>
        标题
        <Input
          value={value?.title}
          disabled={disabled}
          onChange={v => onChange({ ...value, title: v })}
        />
      </div>
      <div className={styles.item}>
        副标题
        <Input
          value={value?.subTitle}
          disabled={disabled}
          onChange={v => onChange({ ...value, subTitle: v })}
        />
      </div>
      <div className={styles.item}>
        按钮
        <Input
          value={value?.buttonName}
          disabled={disabled}
          onChange={v => onChange({ ...value, buttonName: v })}
        />
      </div>
      {isH5 && <div className={styles.item}>
        H5活动配置
        <Input
          value={value?.h5?.url}
          disabled={disabled}
          onChange={v => onChange({ ...value, h5: { ...value?.h5, url: v } })}
        />
      </div>}
      {isQQ && <>
        <div className={styles.item}>
          QQ群号
          <Input
            value={value?.qqGroup?.qq}
            disabled={disabled}
            onChange={v => onChange({ ...value, qqGroup: { ...value?.qqGroup, qq: v } })}
          />
        </div>
        <div>
          群链接
          <Input
            value={value?.qqGroup?.url}
            disabled={disabled}
            onChange={v => onChange({ ...value, qqGroup: { ...value?.qqGroup, url: v } })}
          />
        </div>
      </>}
    </div>
  );
};

export default CustomOfficialActivity;
